<template>
    <section class="header">
        <section class="header-left">
            <section class="d-flex flex-row gap-4 align-items-center">
                <img :src="$appConfig.logo.path" :alt="$appConfig.logo.alt" class="side-bar__logo" />
                <ClockComponent class="text-light" v-if="$store.state.settings.runtime.showClockInOw"/>
            </section>

            <section class="header-right header-right__text">
                <section style="flex: 1;">
                    <p class="header-right__client-name"> {{client}} </p>
                    <p class="header-right__session-name" v-if="session !== null"> {{getPublicSessionName(session, 999999999999)}} </p>
                </section>
                <section v-if="logo != null && logo.length > 0 && $store.state.settings.runtime.clientLogoShowOw === true" >
                    <img :src="logo" class="logo" align="absmiddle"/>
                </section>
            </section>

        </section>
    </section>
</template>

<script charset="utf-8">
    import ClockComponent from "@/components/BasicControls/ClockComponent.vue";
    import { getPublicSessionName } from "@/helpers/session.helper";

    /**
     * Pasek nagłówka okna wizualizacji. Wspólny dla prezentacji posiedzenia i ekranów bez niej
     * (ładowanie, błąd, oczekiwanie na uruchomienie), żeby każdy stan wyglądał jak to samo okno.
     */
    export default {
        name: "VisualizationHeader",
        components: {
            ClockComponent
        },
        props: {
            client: {
                type: String,
                default: ""
            },
            /**
             * null - bez wiersza z nazwą posiedzenia (okno pod stałym linkiem, gdy żadne posiedzenie nie trwa).
             */
            session: {
                type: Object,
                default: null
            },
            logo: {
                type: String,
                default: ""
            }
        },
        methods: {
            getPublicSessionName
        }
    };
</script>

<style lang="scss" scoped>
    .header {
        width: 100%;
        box-sizing: border-box;
        padding: 20px 50px;
        //display: flex;
        justify-content: space-between;
        align-items: center;
        background: radial-gradient( 235.38% 418.45% at 0% 0%, #00082c 0%, #004dcc 100% );
        position: sticky;
        top: 0px;
        z-index: 6;

        &::after {
            content: "";
            position: absolute;
            background: #dde0e7;
            width: 100%;
            height: 1px;
            bottom: -1px;
            left: 0px;
        }
    }

    .header-left {
        display: flex;
        align-items: center;

        .text-light{
            color: #ffffff !important;
        }
        &__icon {
            margin-right: 11px;
        }

        &__text {
            font-size: 16px;
            line-height: 144%;
            color: #333956;

            &--bold {
                font-weight: 600;
            }

            &--link {
                color: #d80418;
                text-decoration: underline;
                font-weight: 600;
            }
        }

        @media only screen and (max-width:1850px) {
            width: 100%;
        }
    }

    .header-right {
        display: flex;
        align-items: center;
        max-width: 700px;

        &__text {
            font-weight: 600;
            font-size: 20px;
            color: white;
            margin-left: auto;
            margin-right: 0;
        }

        &__client-name {
            text-align: center;
        }

        &__session-name {
            font-size: 11px;
            text-align: center;
            font-weight: 200;
            margin-right: 10px;
        }
    }

    .logo {
        width: 80px;
        margin-right: auto;
    }
</style>
